import React, { Fragment } from "react";
import { splitTextForSearchHighlighting } from "../utils/textUtils";

export type HighlightedSearchTextProps = {
  text?: string;
  query: string;
  highlightSnippet?: string;
};

/** Renders `text` with Typesense search hits emphasized (yellow mark). */
export function HighlightedSearchText({
  text,
  query,
  highlightSnippet,
}: HighlightedSearchTextProps) {
  const segments = splitTextForSearchHighlighting(text ?? "", query, highlightSnippet);
  return (
    <>
      {segments.map((s, i) =>
        s.highlight ? (
          <mark key={i} className="bg-yellow-200 inline px-0 leading-inherit">
            {s.text}
          </mark>
        ) : (
          <Fragment key={i}>{s.text}</Fragment>
        ),
      )}
    </>
  );
}
